import { gql } from "@apollo/client";
import { IUser } from "types/User.types";

const GET_CV_HISTORY_PAGINATED = gql`
  query GetPaginatedCvHistory(
    $cvHistoryPaginated: CvHistoryPaginatedInputType!
    $userId: String!
  ) {
    getPaginatedCvHistory(
      cvHistoryPaginated: $cvHistoryPaginated
      UserId: $userId
    ) {
      total
      cvHistoryPaginated {
        name
        id
        offers {
          id
          name
        }
        industries {
          id
          name
        }
        createdBy {
          id
          name
          email
          lastname
          profileImage
          role {
            name
            avatar
          }
        }
        createdAt
        updatedAt
        definedForMarketplace
      }
    }
  }
`;

export interface Education {
  title?: string;
  description?: string;
  visible?: boolean;
  dateStart?: string;
  dateEnd?: string;
}

export interface ExtraEducation {
  title: string;
  description: string;
  visible: boolean;
  dateStart: string;
  dateEnd: string;
}

export interface ExtraWorkExperience {
  company: string;
  date: string;
  description: string;
  title: string;
  visible: boolean;
  toDate?: boolean | false;
  endDate?: string;
}

export interface WorkExperience {
  company: string;
  date: string;
  description: string;
  title: string;
  visible: boolean;
  toDate?: boolean;
  endDate?: string;
}

export interface CvInfo {
  education: Education;
  certifications?: string;
  industries?: string;
  extraEducation?: ExtraEducation[];
  extraWorkExperience?: ExtraWorkExperience[];
  languages?: string;
  workExperience?: WorkExperience;
  tagLine: string;
  techSkills?: string;
  visibleCertifications: boolean;
  visibleIndustries: boolean;
  visibleSkills: boolean;
  visibleLanguages: boolean;
}

export interface CvHistoryDetails {
  name: string;
  user: IUser;
  cvInfo: CvInfo;
  updateAt: string;
  createdAt: string;
}

const GET_CV_VERSION_DETAILS = gql`
  query GetCvHistoryById($getCvHistoryByIdId: String!) {
    getCvHistoryById(id: $getCvHistoryByIdId) {
      name
      createdAt
      updatedAt
      user {
        name
        lastname
        profileImage
        email
        role {
          name
        }
      }
      cvInfo {
        education {
          title
          description
          visible
          dateStart
          dateEnd
        }
        industries
        certifications
        extraEducation {
          title
          description
          visible
          dateStart
          dateEnd
        }
        extraWorkExperience {
          company
          date
          description
          title
          visible
          endDate
          toDate
        }
        languages
        workExperience {
          company
          date
          description
          title
          visible
          endDate
          toDate
        }

        tagLine
        techSkills
        visibleCertifications
        visibleIndustries
        visibleSkills
        visibleLanguages
        visibleIndustries
      }
    }
  }
`;

const GET_PUBLIC_CV_HISTORY = gql`
  query GetPublicCvHistoryById($getPublicCvHistoryByIdId: String!) {
    getPublicCvHistoryById(id: $getPublicCvHistoryByIdId) {
      name
      createdAt
      updatedAt
      user {
        name
        lastname
        profileImage
        email
        rolePublic {
          name
        }
      }
      language
      cvInfo {
        education {
          title
          description
          visible
          dateStart
          dateEnd
        }
        industries
        certifications
        extraEducation {
          title
          description
          visible
          dateStart
          dateEnd
        }
        extraWorkExperience {
          company
          date
          description
          title
          visible
          endDate
          toDate
        }
        languages
        workExperience {
          company
          date
          description
          title
          visible
          endDate
          toDate
        }
        tagLine
        techSkills
        visibleCertifications
        visibleIndustries
        visibleSkills
        visibleLanguages
        visibleIndustries
      }
    }
  }
`;

export default {
  GET_CV_HISTORY_PAGINATED,
  GET_CV_VERSION_DETAILS,
  GET_PUBLIC_CV_HISTORY
};
